<template>
  <EcxModal
    :open="open"
    type="info"
    :icon="LockIcon"
    :show-close-button="false"
    :close-on-backdrop="false"
    :show-actions="false"
    :title="t('views.manager_security_modal.title')"
    :description="t('views.manager_security_modal.description')"
    @update:open="$emit('update:open', $event)"
  >
    <div class="flex justify-center mt-8">
      <EcxButton
        :text="t('views.manager_security_modal.cta')"
        class="min-w-[200px] h-12"
        type="button"
        @click="onConfirm"
      />
    </div>
  </EcxModal>
</template>

<script setup lang="ts">
  import { EcxButton, EcxModal, LockIcon } from '@ecx/ui';
  import { useI18n } from '@/composables/useI18n';

  defineProps<{
    open: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'confirm'): void;
    (e: 'update:open', value: boolean): void;
  }>();

  const { t } = useI18n();

  const onConfirm = () => {
    emit('confirm');
  };
</script>
